import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useHeaderStyles() {
  const { fonts, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      text: {
        fontWeight: 600
      },
      icons: {
        fontSize: fonts.large.fontSize
      },
      filterAddIcon: {
        color: semanticColors.buttonTextDisabled,
        fontSize: fonts.small.fontSize,
        marginLeft: `5px`,
        verticalAlign: `text-top !important`,
        cursor: `pointer`,
        selectors: {
          ":hover": {
            color: semanticColors.buttonTextPressed
          }
        }
      }
    }),
    [fonts, semanticColors]
  );
}
